//@flow
import * as React from 'react'
import type { NemesisQualityReview$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const NemesisQualityReview=(props:NemesisQualityReview$Props)=>{
    const nemesis = props.nemesis
    let isVisible = false

    if (nemesis.reviewQuestions && nemesis.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'nemesisQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'nemesisPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(nemesis.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default NemesisQualityReview


// WEBPACK FOOTER //
// ./src/views/ProjectNemesis/NemesisQualityReview.js